import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import * as d3 from "d3";

const uuidv1 = require('uuid/v1');


export default function Signature(props) {
  let inputArea = React.createRef();
  const [fileID] = useState('file_' + uuidv1());
  let handleClose = () => {
    props.handleClose();
  }

  let handleSave = () => {
    if (inputArea.current.outerHTML.length > 180) {
      props.handleSave(inputArea.current);
      props.handleClose();
    }
  }

  useEffect(() => {
    if (document.documentElement) { document.documentElement.scrollTop = 0 }
    setTimeout(() => {
      signatureAction();
    }, 100);

  }, [])  //added []

  let signatureAction = () => {
    var line = d3.line()
      .curve(d3.curveBasis)
    var svg = d3.select("#svgElement" + fileID)
      .call(d3.drag()
        .container(function () { return this.parentNode; })
        .subject(function () { var p = [d3.event.x, d3.event.y]; return [p, p]; })
        .on("start", dragstarted));

    function dragstarted() {
      var d = d3.event.subject,
        active = svg.append("path").datum(d),
        x0 = d3.event.x,
        y0 = d3.event.y;

      d3.event.on("drag", function () {
        var x1 = d3.event.x,
          y1 = d3.event.y,
          dx = x1 - x0,
          dy = y1 - y0;

        if (dx * dx + dy * dy > 25) d.push([x0 = x1, y0 = y1]);
        else d[d.length - 1] = [x1, y1];
        active.attr("d", line);

      });
    }
  }
  return (
    <div>
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Ondertekening</DialogTitle>
        <DialogContent style={{ minWidth: '400px' }}>
          <DialogContentText>

          </DialogContentText>
          <div style={{ border: '1px solid silver', width: '400px', height: '250px' }}>
            <svg width="400px" height="250px" ref={inputArea} id={'svgElement' + fileID} className="signature" >
              <rect width="100%" height="100%" style={{ fill: 'none' }}></rect>
            </svg>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Annuleren</Button>
          <Button onClick={handleSave} variant="contained" color="primary">AKKOORD</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
